module.exports = __webpack_public_path__ + "img/download_hand.c1a34e95.png";